if (!process.env.VUE_APP_IS_WEB) {
  var ResolutionCatalogDB = require("../database/models/ResolutionCatalog");
}
import settings from "@/database/settings";
import dates from "@/database/dates";
import strings from "@/database/strings";

import ResolutionCatalogORM from "@/store/orm-axios/models/ResolutionCatalog";

import ResolutionMW from "./Resolution";
import TagMW from "./Tag";

import MediaMW from "./Media";

export default {
  FETCH(agencyId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new ResolutionCatalogDB()
          .query({ where: { agency_id: agencyId, deleted: null } })
          .fetchAll({
            withRelated: [
              {
                resolutions: query => {
                  query.where("deleted", null);
                },
              },
              // !!!: get media too
              "resolutions.media",
            ],
          })
          .then(res => {
            ResolutionCatalogORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionCatalogORM.api()
          .FETCH(agencyId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  QUERY_FETCH(agencyId, queryParams) {
    // console.log(agencyId, queryParams);
    if (!process.env.VUE_APP_IS_WEB) {
      var mainTable = "resolution_catalog";
      var pivotTagTable = "resolution_catalog_tag";
      var relatedResolutionTable = "resolution";
      return new Promise((resolve, reject) => {
        new ResolutionCatalogDB()
          .query(qb => {
            qb.select(`${mainTable}.*`);
            qb.where(`${mainTable}.agency_id`, agencyId).whereNull(`${mainTable}.deleted`);

            // filter
            queryParams.filter.forEach(filter => {
              if (filter.column == "*resolutions-catalogs-labels*") {
                qb.innerJoin(
                  `${pivotTagTable}`,
                  `${pivotTagTable}.resolution_catalog_id`,
                  `${mainTable}.id`
                )
                  .where(`${pivotTagTable}.tag_id`, "=", filter.value)
                  .whereNull(`${pivotTagTable}.deleted`);
              } else {
                qb.where(`${mainTable}.${filter.column}`, "LIKE", "%" + filter.value + "%");
              }
            });

            // order
            if (queryParams.sort.by == "*resolutions-catalogs-no-resolutions*") {
              // HACK: order by the number of resolutions it has
              qb.count(`${relatedResolutionTable}.id`, { as: "r" })
                .leftJoin(`${relatedResolutionTable}`, function () {
                  this.on(
                    `${relatedResolutionTable}.resolution_catalog_id`,
                    "=",
                    `${mainTable}.id`
                  ).onNull(`${relatedResolutionTable}.deleted`);
                })
                .groupBy(`${mainTable}.id`)
                .orderBy("r", queryParams.sort.dir);
            } else {
              qb.orderBy(`${mainTable}.${queryParams.sort.by}`, queryParams.sort.dir);
            }
          })
          // .orderBy(queryParams.sort.by, queryParams.sort.dir)
          .fetchPage({
            pageSize: settings.itemsPerPage,
            page: queryParams.page,
            withRelated: [
              {
                resolutions: query => {
                  query.where("deleted", null);
                },
              },
              "resolutions.media",
              // {
              //   tags: query => {
              //     query.where("tag.deleted", null);
              //   },
              // },
            ],
          })
          .then(res => {
            // console.log(res);
            // console.log(res.serialize());
            ResolutionCatalogORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionCatalogORM.api()
          .QUERY_FETCH(agencyId, queryParams)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  FETCH_BY_PAGE(agencyId, queryParams, pagination) {
    console.log(pagination);
    queryParams.page = pagination.page;
    queryParams.pageSize = pagination.pageSize;
    queryParams.itemsPerPage = pagination.pageSize;
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        //  TODO Implement functionality
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionCatalogORM.api()
          .QUERY_FETCH(agencyId, queryParams)
          .then(res => {
            ResolutionCatalogORM.deleteAll();
            ResolutionCatalogORM.insertOrUpdate({
              data: res.response.data["hydra:member"],
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new ResolutionCatalogDB({ id: id, deleted: null })
          .fetch({
            withRelated: [
              {
                resolutions: query => {
                  query.where("deleted", null);
                },
              },
              // {
              //   tags: query => {
              //     query.where("tag.deleted", null);
              //   },
              // },
            ],
          })
          .then(res => {
            ResolutionCatalogORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionCatalogORM.api()
          .GET(id)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  POST(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPost = JSON.parse(JSON.stringify(item));
      itemPost.slug = strings.get_slug(itemPost.name);
      return new Promise((resolve, reject) => {
        new ResolutionCatalogDB(itemPost)
          .save()
          .then(res => {
            ResolutionCatalogORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionCatalogORM.api()
          .POST(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  PUT(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPut = JSON.parse(JSON.stringify(item));
      itemPut.slug = strings.get_slug(itemPut.name);
      return new Promise((resolve, reject) => {
        new ResolutionCatalogDB(itemPut)
          .save(null, { isUpdate: true })
          .then(res => {
            ResolutionCatalogORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionCatalogORM.api()
          .PUT(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DELETE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemDelete = JSON.parse(JSON.stringify(item));
      return new Promise((resolve, reject) => {
        new ResolutionCatalogDB(itemDelete)
          .save(null, { isDelete: true })
          .then(res => {
            ResolutionCatalogORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionCatalogORM.api()
          .DELETE(item)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DUPLICATE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemDuplicate = JSON.parse(JSON.stringify(item));
      var resolutionsDuplicate = JSON.parse(JSON.stringify(item.resolutions));
      var tagsDuplicate = JSON.parse(JSON.stringify(item.tags));

      itemDuplicate.name = "COPY " + itemDuplicate.name;
      itemDuplicate.slug = strings.get_slug(itemDuplicate.name);

      delete itemDuplicate["id"];

      return new Promise((resolve, reject) => {
        new ResolutionCatalogDB(itemDuplicate)
          .save()
          .then(async res => {
            var newResolutionCatalog = res.serialize();

            ResolutionCatalogORM.insertOrUpdate({
              data: newResolutionCatalog,
            });

            for (const resolution of resolutionsDuplicate) {
              var resolutionMedia = JSON.parse(JSON.stringify(resolution.media));
              var resolutionChildResolutions = JSON.parse(
                JSON.stringify(resolution.children_resolutions)
              );

              resolution.resolution_catalog_id = newResolutionCatalog.id;
              await ResolutionMW.POST(resolution)
                .then(async res => {
                  await ResolutionMW.POST_MULTIPLE_CHILD_RESOLUTIONS(
                    resolutionChildResolutions,
                    res
                  )
                    .then(res => {
                      // console.log("duplicate child resolutions res", res);
                    })
                    .catch(err => {
                      // console.log("duplicate child resolutions err", err);
                    });
                  // duplicate files ..
                  if (resolutionMedia.length > 0) {
                    await MediaMW.POST_MULTIPLE_FOR_RESOLUTION(
                      resolutionMedia,
                      "resolution",
                      res.id,
                      true
                    )
                      .then(res => {
                        // console.log("duplicate media res", res);
                      })
                      .catch(err => {
                        // console.log("duplicate media err", err);
                      });
                  }
                })
                .catch(err => {
                  console.log("error post resolution", err);
                });
            }

            for (const tag of tagsDuplicate) {
              await TagMW.ATTACH(tag.id, newResolutionCatalog.id);
            }

            resolve(newResolutionCatalog);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      // TODO: ...
      return new Promise((resolve, reject) => {
        ResolutionCatalogORM.api()
          .DUPLICATE(item)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  CHECK_POSITION(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Need implementation
    } else {
      return new Promise((resolve, reject) => {
        ResolutionCatalogORM.api()
          .CHECK_POSITION(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
